import React, { useState } from "react";
import GenericInput from "../common/GenericInput";
import GenericButton from "../common/genericButton";
import InfoTopBar from "../common/InfoTopBar/InfoTopBar";
import styles from "./profile.module.scss";
const Profile = () => {
  const [edit, setEdit] = useState(false);
  const editHandler = () => {
    setEdit((prev) => !prev);
  };
  return (
    <div className={styles.container}>
      <div style={{ padding: "10px 25px" }}>
        <InfoTopBar heading="Profile" info="" divider={true}>
          <div className={styles.rightInfoBar}>
            <label>Type:</label>
            <div className={styles.selectWrapper}>
              <select>
                <option value="1">ALL</option>
                <option value="2">No JS</option>
                <option value="3">Nice!</option>
              </select>
            </div>
            <label>Assets:</label>
            <div className={styles.selectWrapper}>
              <select>
                <option value="1">ALL</option>
                <option value="2">No JS</option>
                <option value="3">Nice!</option>
              </select>
            </div>
          </div>
        </InfoTopBar>
      </div>
      <div className={styles.profileContainer}>
        <div className={styles.imageContainer}>
          <div className={styles.imageWrapper}>
            <img src={"/assets/person.png"} />
          </div>
          {edit && (
            <div className={styles.editIcon}>
              <img src={"/assets/plus.svg"} />
            </div>
          )}
        </div>

        <label className={styles.name}>Sajid</label>
        <div className={styles.infoWrapper}>
          <GenericInput
            label="Full Name"
            placeholder="Enter your Name "
            type="text"
            withRightIcon={false}
            name="name"
            icon={"/assets/user.svg"}
            disabled={!edit}
            // onChange={changeHandler}
          />
          <GenericInput
            label="Email"
            placeholder="Enter your email "
            type="text"
            withRightIcon={false}
            name="phone"
            icon={"/assets/icons-email.svg"}
            disabled={!edit}
            // onChange={changeHandler}
          />
          <GenericInput
            label="Phone Number"
            placeholder="Enter your Phone Number "
            type="text"
            withRightIcon={false}
            name="email"
            icon={"/assets/phone.svg"}
            disabled={!edit}
            // onChange={changeHandler}
          />
          {!edit ? (
            <div className={styles.buttonWrapper}>
              <GenericButton title={"Edit profile"} onClick={editHandler} />
            </div>
          ) : (
            <div className={styles.buttonWrapper}>
              <GenericButton title={"Cancel"} onClick={editHandler} />
              <GenericButton title={"Save"} onClick={editHandler} />
            </div>
          )}
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Profile;
